import { render } from "./OfferConfigurations.vue?vue&type=template&id=aac61b8a&scoped=true"
import script from "./OfferConfigurations.vue?vue&type=script&lang=js"
export * from "./OfferConfigurations.vue?vue&type=script&lang=js"

import "./OfferConfigurations.vue?vue&type=style&index=0&id=aac61b8a&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aac61b8a"]])

export default __exports__